import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import {
  fetchHomeJsonList,
  saveThemeJsonData,
  fetchCroppedImage,
} from "../../../redux/Actions";
import { ColorPicker } from "primereact/colorpicker";

function SectionOurServiceThemeFiveEdit() {
  const dispatch = useDispatch<any>();
  const [editData, setEditData] = useState<any>();
  const [activeTab, setActiveTab] = useState(0);
  const [imagedata, setImagedata] = useState<any>("" || undefined);
  const data: any = useSelector<any>((state) => state.homeJsonList);
  const section6 = editData?.theme_5?.home?.section_our_services;

  const icons = [
    "assets/img/services/service-icon-1.png",
    "assets/img/services/service-icon-2.png",
    "assets/img/services/service-icon-3.png",
    "assets/img/services/service-icon-4.png",
    "assets/img/services/service-icon-5.png",
    "assets/img/services/service-icon-6.png",
    "assets/img/services/service-icon-7.png",
    "assets/img/services/service-icon-8.png",
    "assets/img/services/service-icon-9.png"
  ];
  useEffect(() => {
    setEditData(data);
  }, [data]);

  const saveJsonDataToFile = () => {
    dispatch(fetchHomeJsonList(editData));
    dispatch(saveThemeJsonData(editData));
  };
  const handleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCollection: any = [
      ...editData.theme_5.home.section_our_services.service_section.services,
    ];
    if (index != undefined) {
      updatedCollection = [
        ...editData.theme_5.home.section_our_services.service_section.services,
      ];
      updatedCollection[index] = {
        ...updatedCollection[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_our_services: {
            ...prevJsonData.theme_5.home.section_our_services,
            [name]: value,
            btn_group: {
                ...prevJsonData?.theme_5?.home.section_our_services.btn_group,
                btn1: {
                  ...prevJsonData?.theme_5?.home.section_our_services.btn_group.btn1,
                  [name]: value,
                },
              },
            service_section: {
              ...prevJsonData.theme_5.home.section_our_services.service_section,
              ...prevJsonData.theme_5.home.section_our_services.service_section.services[
                index
              ],
              services: updatedCollection,
            },
          },
        },
      },
    }));
  };

  const removeCollection = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_5.home.section_our_services.service_section.services,
    ];
    updatedCollection.splice(index, 1);
    setActiveTab(activeTab - 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_our_services: {
            ...prevJsonData.theme_5.home.section_our_services,
            service_section: {
              services: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [
      ...editData.theme_5.home.section_our_services.service_section.services,
    ];
    updatedCollection[index] = {
      ...updatedCollection[index],
      service_image: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_our_services: {
            ...prevJsonData.theme_5.home.section_our_services,
            service_section: {
              services: updatedCollection,
            },
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setImagedata(image);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleImageChange(imageLink, activeTab);
    }
  };


  const updateImageSection = async (e: any) => {
    const image = e.target.files[0];
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_5.home.section_our_services.service_section.services,
    ];

    let newCard = {
      service_title: "",
      service_image: "assets/img/services/service-icon-1.png",
      isEnabled: true,
      service_description: "",
      service_text:""
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_our_services: {
            ...prevJsonData.theme_5.home.section_our_services,
            service_section: {
              services: updatedCollection,
            },
          },
        },
      },
    }));
  };
  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section Our Services Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={section6?.title}
                      onChange={(e) => {
                        if (e.target.value.length < 120) {
                          handleChange(e);
                        }
                      }}
                      maxLength={250}
                    />
                  </div>
                  <div className="mb-3">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Button</label>
                    <input
                      type="text"
                      className="form-control"
                      name="text"
                      value={
                        editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                          ?.text
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Background</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="bg_color"
                        value={
                          editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                            ?.bg_color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="bg_color"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        format="hex"
                        value={
                          editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                            ?.bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="color"
                        value={
                          editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                            ?.color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="color"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        format="hex"
                        value={
                          editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                            ?.color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_5?.home?.section_our_services?.service_section?.services.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? "active" : ""
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card Section {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCollection(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_5?.home?.section_our_services?.service_section?.services.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? "show active" : ""
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img
                              src={card.service_image}
                              alt={`Card Icon ${index + 1}`}
                            />
                          </div>
                          <div className="img-options w-100">
                            <Swiper
                              spaceBetween={15}
                              navigation={true}
                              modules={[Navigation]}
                              breakpoints={{
                                640: {
                                  slidesPerView: 1,
                                },
                                768: {
                                  slidesPerView: 4,
                                },
                                1024: {
                                  slidesPerView: 6,
                                },
                              }}
                              className="homejson-slider"
                            >
                              {icons.map((icons, iconIndex) => (
                                <SwiperSlide key={iconIndex}>
                                  <div
                                    className="img-option"
                                    onClick={() =>
                                      handleImageChange(icons, index)
                                    }
                                  >
                                    <img
                                      src={icons}
                                      alt="Hero Image"
                                      className="img-fluid"
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Title<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="service_title"
                          value={card.service_title}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Paragraph<small>(max 1200 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="service_description"
                          value={card.service_description}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={1200}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Description<small>(max 1200 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="service_text"
                          value={card.service_text}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={1200}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className="form-control"
                          name="image"
                          onChange={updateImageSection}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonDataToFile();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionOurServiceThemeFiveEdit;
